export const STATE_PENDING = 'pending';
export const STATE_LOADING = 'loading';
export const STATE_READY = 'ready';
export const STATE_ERROR = 'error';
